// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cost-increase {\n  background-color: rgb(253, 161, 161);\n  padding: 5px;\n}\n.cost-decrease {\n  background-color: rgb(166, 251, 166);\n}\n", ""]);
// Exports
module.exports = exports;
